import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { MfaError } from '../types/mfaErrors'

export interface LoginMFAProps {
	challengeId: string
}

export const resendOtpCode = createAsyncThunk<
	void,
	LoginMFAProps,
	ThunkConfig<{ message: string | undefined, errorStatus?: MfaError }>
>('login/resendOtpCode', async ({ challengeId }, thunkAPI) => {

	const { extra: { api }, rejectWithValue } = thunkAPI

	try {
		await api.post('/mfa/resend', { challengeId })
	} catch (e: any) {
		console.log(e)
		const message = (e.response?.data?.message || e.message) as string | undefined
		const errorStatus = (e.response?.data?.errorStatus) as MfaError | undefined
		return rejectWithValue({ message, errorStatus })
	}
})
